import { render, staticRenderFns } from "./tab3TeacherFacilitatorAnalysis.vue?vue&type=template&id=7977aaab&scoped=true"
import script from "./tab3TeacherFacilitatorAnalysis.vue?vue&type=script&lang=js"
export * from "./tab3TeacherFacilitatorAnalysis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7977aaab",
  null
  
)

export default component.exports